const text = {};

export default text;
